import React from "react";
import { Link } from "react-scroll";
import { MdVerticalAlignTop } from "react-icons/md";
const GoTo = ({ name, visible }) => {
  return (
    <>
      <div className={visible ? " flex" : "hidden"}>
        <div className="fixed z-50 rounded-full bg-white/30 bottom-5 hover:animate-bounce right-5">
          <div className="p-2">
            <Link
              to={name}
              smooth={true}
              className="font-extrabold "
              duration={1500}
            >
              <MdVerticalAlignTop aria-label="go to top" size={30} />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default GoTo;
